export default __webpack_public_path__ + "static/media/student_exchange.b0d88f43.jpg";